var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:report-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 17.2048C12.2833 17.2048 12.521 17.1088 12.713 16.9168C12.905 16.7248 13.0007 16.4874 13 16.2048C12.9993 15.9221 12.9033 15.6848 12.712 15.4928C12.5207 15.3008 12.2833 15.2048 12 15.2048C11.7167 15.2048 11.4793 15.3008 11.288 15.4928C11.0967 15.6848 11.0007 15.9221 11 16.2048C10.9993 16.4874 11.0953 16.7251 11.288 16.9178C11.4807 17.1104 11.718 17.2061 12 17.2048ZM11 13.2048H13V7.20477H11V13.2048ZM8.25 21.2048L3 15.9548V8.45477L8.25 3.20477H15.75L21 8.45477V15.9548L15.75 21.2048H8.25ZM9.1 19.2048H14.9L19 15.1048V9.30477L14.9 5.20477H9.1L5 9.30477V15.1048L9.1 19.2048Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.06739e52d00fac7bc8e96cf7e906126d.svg";
export { ForwardRef as ReactComponent };